// you can import modules from the theme lib or even from
// NPM packages if they support it…
//import ExampleComponent1 from "./components/ExampleComponent1";

// you can also require modules if they support it…
//const ExampleModule2 = require('./components/example-2');

// Some convenient tools to get you started…
//import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
//import AnimateOnPageLinks from "./components/AnimateOnPageLinks";

// Initialise our components on jQuery.ready…
// jQuery(function ($) {
//     ExampleComponent1.init();
//     ExampleModule2.init();
//     ReplaceObfuscatedEmailAddresses.init();
//     AnimateOnPageLinks.init();
// });
import $ from "jquery";
import "./../../javascripts/jquery.nav.js";
// you can import modules from the theme lib or even from
// NPM packages if they support it…
import scrollHeader from "./components/header";
import contactModal from "./components/modal";
import SwiperCarousel from "./components/swiper-carousel";
import ApartmentsTable from "./components/apartments-table";

// Vendor animations
jQuery(".menu").onePageNav({
  filter: ":not(.external)",
});
init();
// components
function init() {
  jQuery(function ($) {
    scrollHeader.init();
    contactModal.init();
    SwiperCarousel.init();
    ApartmentsTable.init();
  });
} // all site scripts
console.log(
  "%c%s",
  "border-radius: 6px; padding: 8px; color: #ffffff; background: #171616;",
  "✨ Design: Digicomm | Development: Oliver Rull (oliver@no11.ee)"
);
